import { axios } from "@cores/axiosWrapper";

export const getThreadsAPI = (apiEndpoint, projectId, params, signal) => {
    return axios.get(`${apiEndpoint}/threads`, {
        params,
        headers: {
            projectId,
        },
        signal,
    });
};

export const getThreadAPI = (apiEndpoint, projectId, threadId, customErrorMessage, signal) => {
    return axios.get(`${apiEndpoint}/threads/${threadId}`, {
        headers: {
            projectId,
        },
        customErrorMessage,
        signal,
    });
};

export const getCommentsAPI = (apiEndpoint, projectId, threadId, params, signal) => {
    return axios.get(`${apiEndpoint}/threads/${threadId}/comments`, {
        params,
        headers: {
            projectId,
        },
        signal,
    });
};

export const getCommentAPI = (apiEndpoint, projectId, threadId, commentId, signal) => {
    return axios.get(`${apiEndpoint}/threads/${threadId}/comments/${commentId}`, {
        headers: {
            projectId,
        },
        signal,
    });
};

export const createThreadAPI = (apiEndpoint, projectId, data, signal) => {
    return axios.post(`${apiEndpoint}/threads`, data, {
        headers: {
            projectId,
        },
        signal,
    });
};

export const updateThreadAPI = (apiEndpoint, projectId, threadId, data, signal) => {
    return axios.patch(`${apiEndpoint}/threads/${threadId}`, data, {
        headers: {
            projectId,
        },
        signal,
    });
};

export const createCommentAPI = (apiEndpoint, projectId, threadId, data, signal) => {
    return axios.post(`${apiEndpoint}/threads/${threadId}/comments`, data, {
        headers: {
            projectId,
        },
        signal,
    });
};

export const updateCommentAPI = (apiEndpoint, projectId, threadId, commentId, data, signal) => {
    return axios.patch(`${apiEndpoint}/threads/${threadId}/comments/${commentId}`, data, {
        headers: {
            projectId,
        },
        signal,
    });
};

export const deleteThreadAPI = (apiEndpoint, projectId, threadId, signal) => {
    return axios.delete(`${apiEndpoint}/threads/${threadId}`, {
        headers: {
            projectId,
        },
        signal,
    });
};

export const deleteCommentAPI = (apiEndpoint, projectId, threadId, commentId, signal) => {
    return axios.delete(`${apiEndpoint}/threads/${threadId}/comments/${commentId}`, {
        headers: {
            projectId,
        },
        signal,
    });
};

export const createActionsAPI = (apiEndpoint, projectId, threadId, commentId, data, signal) => {
    return axios.post(`${apiEndpoint}/threads/${threadId}/comments/${commentId}/actions`, data, {
        headers: {
            projectId,
        },
        signal,
    });
};

export const getThreadMembersAPI = (apiEndpoint, projectId, threadId, signal) => {
    return axios.get(`${apiEndpoint}/threads/${threadId}/entities`, {
        headers: {
            projectId,
        },
        signal,
    });
};

export const updateThreadMembersAPI = (apiEndpoint, projectId, threadId, data, signal) => {
    return axios.post(`${apiEndpoint}/threads/${threadId}/entities`, data, {
        headers: {
            projectId,
        },
        signal,
    });
};

export const deleteCommentAttachmentAPI = (apiEndpoint, projectId, threadId, commentId, attachmentId, signal) => {
    return axios.delete(`${apiEndpoint}/threads/${threadId}/comments/${commentId}/attachments/${attachmentId}`, {
        headers: {
            projectId,
        },
        signal,
    });
};

export const addCommentAttachmentsAPI = (apiEndpoint, projectId, threadId, commentId, data, signal) => {
    return axios.post(`${apiEndpoint}/threads/${threadId}/comments/${commentId}/attachments`, data, {
        headers: {
            projectId,
        },
        signal,
    });
};
